import React from 'react'

import FileDocPreview from '@core/components/FilePreviewWindow/FileDocPreview/FileDocPreview'
import FileImagePreview from '@core/components/FilePreviewWindow/FileImagePreview/FileImagePreview'
import FilePdfPreview from '@core/components/FilePreviewWindow/FilePdfPreview/FilePdfPreview'
import FileRecDocumentPreview from '@core/components/FilePreviewWindow/FileRecDocumentPreview/FileRecDocumentPreview'
import FileUnsupportedPreview from '@core/components/FilePreviewWindow/FileUnsupportedPreview/FileUnsupportedPreview'
import { useFilePreview } from '@core/utils/contexts/FilePreviewContext/FilePreviewContext'

import './FilePreviewWindow.scss'

const pageableExtension = ['docx', 'doc', 'pptx', 'ppt', 'xlsx', 'xls']
const pdfExtension = ['pdf']
const imageExtension = ['jpg', 'jpeg', 'png']
const recmanDocumentExtension = ['recmanDocument']

const FilePreviewWindow: React.FC = () => {
    const { previewFile, isOpen, closePreview, fileExtension, disabled, folder } = useFilePreview()

    if (!previewFile || !isOpen) return null

    if (disabled && previewFile && (previewFile?.downloadUrl || previewFile?.downloadLink || previewFile?.File)) {
        window.open(`${previewFile.downloadUrl || previewFile.downloadLink || previewFile.File}`, '_blank')
        closePreview()
        return
    }

    if (previewFile.FileTypeID === 2 && previewFile.File) {
        window.open(`${previewFile.File}`, '_blank')
        closePreview()
        return
    }
    if (previewFile.type === 'url' && previewFile.downloadUrl) {
        window.open(`${previewFile.downloadUrl}`, '_blank')
        closePreview()
        return
    }

    if (folder === 'tmp-apply-file' && !previewFile.CandidateFileID && !pdfExtension.includes(fileExtension)) {
        return <FileUnsupportedPreview />
    }

    if (previewFile.FileTypeID === 3 || previewFile.ext === 'html' || previewFile.type === 'document') {
        return <FileRecDocumentPreview />
    }

    if (pageableExtension.includes(fileExtension)) {
        return <FileDocPreview />
    }
    if (pdfExtension.includes(fileExtension)) {
        return <FilePdfPreview />
    }
    if (imageExtension.includes(fileExtension)) {
        return <FileImagePreview />
    }
    if (recmanDocumentExtension.includes(fileExtension)) {
        return <FilePdfPreview />
    }
    return <FileUnsupportedPreview />
}

export default FilePreviewWindow
